import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenu = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 14 5",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M3.5 2.48486C3.5 3.45136 2.7165 4.23486 1.75 4.23486C0.783502 4.23486 0 3.45136 0 2.48486C0 1.51836 0.783502 0.734863 1.75 0.734863C2.7165 0.734863 3.5 1.51836 3.5 2.48486Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 2.48486C14 3.45136 13.2165 4.23486 12.25 4.23486C11.2835 4.23486 10.5 3.45136 10.5 2.48486C10.5 1.51836 11.2835 0.734863 12.25 0.734863C13.2165 0.734863 14 1.51836 14 2.48486Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 4.23486C7.9665 4.23486 8.75 3.45136 8.75 2.48486C8.75 1.51836 7.9665 0.734863 7 0.734863C6.0335 0.734863 5.25 1.51836 5.25 2.48486C5.25 3.45136 6.0335 4.23486 7 4.23486Z",
			fill: "black"
		})
	]
});
const ForwardRef = forwardRef(SvgMenu);
export default ForwardRef;
